<template>
	<CModal title="Modifier un point de retrait" size="lg" :show.sync="showModal" :key="timestamp">
		<form ref="mainForm" :action="item['@id']" method="post" axiosMethod="patch">
			<pickup-points-form :item="item" />
		</form>

		<template #footer>
			<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
			<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Sauvegarder</CButton>
		</template>
	</CModal>
</template>

<script>
	import PickupPointsForm from '@/views/pages/pick-up-points/pickup-points-form';
	export default {
		name: 'pickup-points-edit',
		components: { PickupPointsForm },
		data() {
			return {
				showModal: false,
				item: {},
				timestamp: 0,
			};
		},
		methods: {
			onSubmit: async function (form) {
				await this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Le point de retrait a bien été modifié.');
						this.showModal = false;
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>
